import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-public-offer-courier',
  templateUrl: './public-offer-courier.component.html',
})
export class PublicOfferCourierComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'public-offer-busy-fly-courier.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
